import React, { FC } from 'react';
import { Alert as BaseAlert, AlertProps } from 'antd';
import cx from 'classnames';

import { WarningCircle } from 'components/icons';

import styles from './styles.module.css';

const Alert: FC<AlertProps> = ({
  className,
  icon = <WarningCircle />,
  showIcon = true,
  ...props
}) => (
  <BaseAlert
    className={cx(styles.root, className)}
    icon={icon}
    showIcon={showIcon}
    {...props}
  />
);

export default Alert;
